<script context="module">
	import { vehicleStatusVariantByLabel } from "src/utils/options";
	import { statusBadgeStyle } from "src/utils/statusBadge";

	const variantByLowerLabel = Object.fromEntries(
		Object.entries(vehicleStatusVariantByLabel).map(([label, variant]) => [
			label.toLowerCase(),
			variant,
		])
	);

	export const optionBadgeStyle = (item) =>
		statusBadgeStyle(
			item.variant ?? variantByLowerLabel[item.label.trim().toLowerCase()]
		);
</script>

<script>
	export let item = undefined;
	export let isActive = false;
	export let isHover = false;
	// Props svelte-select passes to every Item component.
	export const isFirst = false;
	export const isSelectable = false;
	export const getOptionLabel = undefined;
	export const filterText = "";
</script>

<div class="status-item" class:active={isActive} class:hover={isHover}>
	<span class="status-badge" style={optionBadgeStyle(item)}>
		{item.label.toUpperCase()}
	</span>
</div>

<style>
	.status-item {
		display: flex;
		align-items: center;
		height: 48px;
		padding: 12px 16px;
		cursor: pointer;
	}

	.status-item.hover,
	.status-item.active {
		background-color: var(--fds-surface-container-low, #f1f1f1);
	}

	.status-badge {
		border-radius: 4px;
		padding: 4px 8px;
		font-size: 12px;
		font-weight: bold;
		line-height: 16px;
		white-space: nowrap;
	}
</style>
